import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Main } from '../../../../../constant';
import { Input } from '../../../../../components/input/input';
import { Box, Checkbox, FormControlLabel, FormGroup, Grid, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import RadioButn from '../../../../../components/radioButn/radioButn';
import { CustomBtn } from '../../../../../components/button/button';
import CustomForm from '../../../../../components/form/form';
import { StudentRegistation } from '../../../../../redux/actions/registration/studentregistation';
import { useDispatch, useSelector } from 'react-redux';
import { UserData } from '../../../../../hooks/FirstTimeWebSrn/Websrn';
import { DateGlobalConvertor } from '../../../../../components/Date/DateGlobalConverter'
import dayjs from 'dayjs';

const Auth = (props) => {
    const WebSrn = localStorage.getItem('WebSrn') 
    const [data, setData] = useState(WebSrn == 12 ?  Main().RegistrationDari : WebSrn == 13 ? Main().RegistrationRawayatAcademy : Main().Registration);
    const dispatch = useDispatch();
    const api = useSelector((state) => state.Api)
    const getfilterdata = data.inputs.filter((item) => item.feildtype !== 'label');
    const [loadDate, setLoadDate] = useState(DateGlobalConvertor(dayjs(Date.now())))
    const initialInputValues = Object.fromEntries(
        getfilterdata
            .map((item) => [item.name, ''])
    );
    ////console.log(initialInputValues)
    const [inputValues, setInputValues] = useState(initialInputValues);

    const [butnVisiablity, setButnVisiablity] = useState(true)
    const [getMessage, setGetMessage] = useState('')
    const [formKey, setFormKey] = useState(0);

    function handleInputChange(e) {
        if (inputValues.AdmissionDate === '') { 
            updateAdmDate()
        }
        //console.log(inputValues)
        setInputValues((prevValues) => ({
            ...prevValues,
            [e.target.name]: e.target.value,
        }));
    }

    function handleRadioChange(e, chk) {
        // data.inputs.forEach((field, index) => {
        //     if (field.feildtype === 'radio') {
        //         if (field.name === e.target.name && field.data === 'Yes') {
        //             field.check = true;
        //             hostelFound = true;
        //         } else if (field.name === e.target.name && field.data === 'No') {
        //             if (hostelFound) {
        //                 field.check = false;
        //                 hostelFound = false;
        //             } else {
        //                 field.check = true;
        //             }
        //         }
        //     }
        // });
        //console.log(e, chk)
        setInputValues((prevValues) => ({
            ...prevValues,
            [e.target.name]: e.target.placeholder,
        }));
        // e.target.checked == !e.target.checked
        //console.log(inputValues)
    }
    const ChangeOnSelect = (getparam) => {
        console.log(getparam)
        // return false


        if(getparam[1] == "Picture"){
            setInputValues((oldData) => ({
                ...oldData,
                [getparam[1]]: getparam[0],
                
                // [getparam[2]]: getparam[3],
                // [getparam[1]]: getparam[0],
            })
        )
        }
        else{
            setInputValues((oldData) => ({
                ...oldData,
                Class: getparam[0],
                ClassName: getparam[1],
                
                // [getparam[2]]: getparam[3],
                // [getparam[1]]: getparam[0],
            })
        )

        }
    }
    const ChangeClass = (getparam) => {
        console.log(getparam)
        setInputValues((oldData) => ({
            ...oldData,
            Class: getparam[0],
            ClassName: getparam[1],
        }))
    }

    const myfunc = async (event) => {
    event.preventDefault();
    setButnVisiablity(false);

    try {
        const getMsg = await dispatch(
            StudentRegistation(
                api.StudentRegistation, 
                JSON.parse(sessionStorage.getItem("User_Data")).token, 
                JSON.stringify(inputValues)
            )
        );
        console.log("Got back message:", getMsg); // 👈 now works
        setGetMessage(getMsg)
            dispatch({
                    type: 'SHOW_MODAL',
                    response: getMsg,
                    severity: 'Success'
                });
        setTimeout(() => {
            refreshForm();
            setInputValues(initialInputValues);
            setButnVisiablity(true);
        }, 1000);
    } catch (err) {
        console.error("Registration failed:", err);
        setButnVisiablity(true);
    }
};

    
    function updateAdmDate(){
        setInputValues((prevValues) => ({
            ...prevValues,
            'AdmissionDate': loadDate.formatNormalDate,
            'admGrDate': loadDate.gregorianDate,
            'admArDate': loadDate.arabicDate,
        }));
        //console.log(inputValues)
    }

    const ChangeDate = (e, name, grDate, arDate) => {
        const grDateConst = name != 'DOB' ? 'admGrDate' : 'dobGrDate';
        const arDateConst = name != 'DOB' ? 'admArDate' : 'dobArDate';
        setInputValues((prevValues) => ({
            ...prevValues,
            [name]: e,
            [grDateConst]: grDate,
            [arDateConst]: arDate
        }));
    }
    // Function to refresh the form
    const refreshForm = () => {
        setFormKey(prevKey => prevKey + 1);
    }


// console.log(formattedMessage);

    
    return (
        <form onSubmit={myfunc} className='studentRegistration'>
            <Grid container >
                <CustomForm key={formKey} data={data.inputs} GetSelectedClass = {ChangeClass} ChangeOnSelect={ChangeOnSelect} ChangeDate={ChangeDate} handleRadioChange={handleRadioChange} handleInputChange={handleInputChange} />
            </Grid>
            <Grid container mt={1}>
                <Grid lg={3} item>
                    <Box>

                    </Box>
                </Grid>
                <Grid lg={6} item>
                    <Box>
                        <CustomBtn disable={!butnVisiablity} data={data.butn} style={{ margin: 'auto', display: 'block', marginTop: '10px' }} />
                    </Box>
                </Grid>
                <Grid lg={12} item>
                    <Box style={{  textAlign:'center', fontSize:'20px', margin: 'auto', display: 'flex', justifyContent:"center", padding:"20px", marginTop: '10px',  color:'#ffa800'}}>
                        {/* {getMessage && getMessage.length > 0? 
                            `> ${getMessage.split(',')[1]}  RollNumber ${getMessage.split(',')[0]} in ${getMessage.split(',')[2]}`
                            : null
                            } */}
                                {getMessage && getMessage.length > 0 && (() => {
                                const [rollNumber, name, course] = getMessage.split(',');

                                return (
                                    <label style={{ display: 'block', width: 'fit-content' }}>
                                    <div
                                        style={{
                                        borderRadius: '16px',
                                        padding: '20px 24px',
                                        boxShadow: 'rgb(71 165 75 / 36%) 0px 0px 18px, rgba(255, 255, 255, 0.8) 0px 0px 0px',
                                        transition: 'all 0.3s ease',
                                        fontFamily: 'Roboto, sans-serif',
                                        maxWidth: '320px',
                                        cursor: 'default',
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-4px)'}
                                        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                    >
                                        <Typography
                                        variant="h5"
                                        component="div"
                                        sx={{ fontWeight: 700, color: '#222', marginBottom: 1 }}
                                        >
                                        {name}
                                        </Typography>
                                        <Typography
                                        variant="body1"
                                        component="div"
                                        sx={{ color: '#555', marginBottom: 0.5 }}
                                        >
                                        RollNumber {rollNumber}
                                        </Typography>
                                        <Typography
                                        variant="body1"
                                        component="div"
                                        sx={{ color: '#888', fontStyle: 'italic' }}
                                        >
                                         {course}
                                        </Typography>
                                    </div>
                                    </label>
                                );
                                })()}


                    </Box>
                </Grid>
            </Grid>
        </form>
    );
};

Auth.propTypes = {};

export default Auth;


